/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRadio = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m5.311 4 1.377 1.45C4.976 7.077 4.021 9.259 4 11.595c-.022 2.402.938 4.681 2.701 6.417l-1.403 1.426C3.145 17.317 1.974 14.525 2 11.577 2.026 8.695 3.202 6.003 5.311 4zM18.69 4c2.109 2.003 3.285 4.695 3.31 7.577.027 2.948-1.144 5.74-3.297 7.861L17.3 18.012c1.763-1.736 2.723-4.015 2.7-6.417-.02-2.336-.975-4.518-2.687-6.145zM7.283 6.027l1.434 1.395c-2.29 2.355-2.287 6.22.005 8.611l-1.444 1.383c-3.028-3.16-3.026-8.27.005-11.389zm9.434 0c3.031 3.12 3.033 8.23.005 11.39l-1.444-1.384c2.292-2.392 2.294-6.256.005-8.61zM12 9c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 2a1 1 0 1 0 0 2.001 1 1 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgRadio as Radio };
